"use strict";"production"===process.env.NODE_ENV?module.exports=require("./js/react-notifications.prod.js"):module.exports=require("./js/react-notifications.dev.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-notifications-component/dist/index.js
// module id = ./node_modules/react-notifications-component/dist/index.js
// module chunks = 1